import { render } from "./FeedbackDashboard.vue?vue&type=template&id=a2258c6e&scoped=true"
import script from "./FeedbackDashboard.vue?vue&type=script&lang=js"
export * from "./FeedbackDashboard.vue?vue&type=script&lang=js"

import "./FeedbackDashboard.vue?vue&type=style&index=0&id=a2258c6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2258c6e"]])

export default __exports__